import { useRef, useEffect } from 'react';

export default areMobileFiltersOpen => {
  const checkboxRef = useRef();
  useEffect(() => {
    if (!areMobileFiltersOpen && checkboxRef) {
      setTimeout(() => {
        checkboxRef.current.checked = false;
      }, 300);
    }
  }, [areMobileFiltersOpen]);
  return checkboxRef;
};
